import { reportV2ActionTypes } from '../../actions/Reports/reportV2Actions';

const ReportV2Reducers = (state = {}, action) => {
  switch (action.type) {
  case reportV2ActionTypes.GET_REPORTS_LIST_V2.LOADING: {
    const { getReportsV2ListLoading } = action;
    return {
      ...state,
      getReportsV2ListLoading,
    };
  }
  case reportV2ActionTypes.GET_REPORTS_LIST_V2.SUCCESS: {
    const { reportsV2ListData } = action;
    return {
      ...state,
      reportsV2ListData,
    };
  }

  // filter reports v2 List
  case reportV2ActionTypes.FILTER_REPORTS_LIST_V2.LOADING: {
    const { filterReportsV2ListLoading } = action;
    return {
      ...state,
      filterReportsV2ListLoading,
    };
  }

  // get reports v2 List Detail
  case reportV2ActionTypes.GET_REPORTS_LIST_V2_DETAIL.LOADING: {
    const { getReportsV2ListDetailLoading } = action;
    return {
      ...state,
      getReportsV2ListDetailLoading,
    };
  }

  case reportV2ActionTypes.GET_REPORTS_LIST_V2_DETAIL.SUCCESS: {
    const { reportsV2ListDetailData } = action;
    return {
      ...state,
      reportsV2ListDetailData,
    };
  }

  case reportV2ActionTypes.DELETE_SCHEDULED_REPORT.LOADING: {
    const { deleteScheduledReportLoading } = action;
    return {
      ...state,
      deleteScheduledReportLoading,
    };
  }
  case reportV2ActionTypes.GET_REPORTS_BY_ID.LOADING: {
    const { getReportsByIdLoading } = action;
    return {
      ...state,
      getReportsByIdLoading,
    };
  }

  default: {
    return state;
  }
  }
};
export default ReportV2Reducers;
